import { takeLatest, put, call } from 'redux-saga/effects';

import { findTransportadoraCadastro } from '../service';
import {
  FIND_TRANSPORTADORA_CADASTRO,
  FIND_TRANSPORTADORA_CADASTRO_PENDING,
  FIND_TRANSPORTADORA_CADASTRO_SUCCESS,
  FIND_TRANSPORTADORA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaFindTransportadoraCadastro(action) {
  yield put({ type: FIND_TRANSPORTADORA_CADASTRO_PENDING, id: action.id })

  try {

    const registro = yield call(findTransportadoraCadastro, action.id);

    yield put({ type: FIND_TRANSPORTADORA_CADASTRO_SUCCESS, registro: registro })

  } catch (error) {

    yield put({ type: FIND_TRANSPORTADORA_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindTransportadoraCadastro() {
  yield takeLatest(FIND_TRANSPORTADORA_CADASTRO, sagaFindTransportadoraCadastro)
}
